import { QuizToolResponse, SizingToolResponse } from './response';
import { trackQuizToolUserResponse, trackSizingToolUserResponse } from '../../../tracking/events';

export class HoneyLoveService {
  public static instance: HoneyLoveService = new HoneyLoveService();

  public async saveResponse(response: SizingToolResponse): Promise<void> {
    if (!response.clientId) {
      return;
    }

    try {
      trackSizingToolUserResponse({
        sizingToolUserResponse: {
          sizingToolStepKey: response.stepKey,
          sizingToolEngineValue: response.engineValue,
          sizingToolResponse: response.value,
          sizingToolSessionGuid: response.sessionGuid,
        },
        handle: response.productHandle ?? undefined,
      });
    } catch (error) {
      // console.error(error);
      return;
    }
  }

  public async saveQuizResponse(quizToolUserResponse: QuizToolResponse): Promise<void> {
    console.log('saveQuizResponse: ', { quizToolUserResponse });
    if (!quizToolUserResponse.clientId) {
      return;
    }

    try {
      trackQuizToolUserResponse({ quizToolUserResponse });
    } catch (error) {
      // console.error(error);
      return;
    }
  }
}
